module.exports = __webpack_public_path__ + "fonts/Font5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font5.ttf
// module id = 1734
// module chunks = 0